import React, {useContext, useEffect} from "react";
import {Link} from 'react-router-dom'

import {Loading} from '../custom/LoadingComponent'
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';

import ClientTabsRenderer from './ClientTabsRendererComponent';
import BucketContext from "../context/BucketContext";
import * as ReduxDataStatus from '../../utils/constants/ReduxDataStatus';


const MyClientManagement = (props) => {
    const bucketContext = useContext(BucketContext);

    console.log('___ MyClient ___');

    useEffect(() => {
            props.loadComponentData(props.myClientId);
    }, [props.myClientId]);

    if(props.dataStatus === ReduxDataStatus.IDLE || 
       props.dataStatus === ReduxDataStatus.LOADING) {
         return (
            <Container maxWidth="xl" >
                <Box px={{ xs: 3, sm: 7 }}>
                    <Loading />
                </Box>
            </Container>
        );
    }
    else if (props.client != null) {

        return (
            <Container maxWidth="xl" >
                <Box px={{ xs: 3, sm: 7 }}>

                    <Stack spacing={1} sx={{ marginBottom: 2 }}>
                        <Box>
                            <Breadcrumbs aria-label="breadcrumb" sx={{ mt: 1, mb: 1 }}>
                                <Link to="/home">Acasa</Link>
                                <Typography color="text.primary">{props.client.generalSection.clientName}</Typography>
                            </Breadcrumbs>
                        </Box>

                        <Box>
                            <h3>Client: {props.client.generalSection.clientName}</h3>
                        </Box>
                        <hr />

                        <ClientTabsRenderer
                            client={props.client}
                            clientSubcontractanti={props.clientSubcontractanti}
                            clientSubcontracted={props.clientSubcontracted}
                            allClients={props.allClients}
                            patchClient={props.patchClient}
                        />

                    </Stack>

                </Box>
            </Container>
        );
    } else {
        console.log('Here Here....')

        return (
            <div></div>
        );
    }
}


export default MyClientManagement